module.exports = __webpack_public_path__ + "static/media/2026-calendar-promo-popup-square.1fe5352b.jpg";